import { z } from 'zod';

export const zTokenDataSchema = z.object({
  inserted_at: z.string(),
  expires_at: z.string(),
  level: z.string(),
  token: z.string(),
});

export const zTokenExtraSchema = z.object({
  type: z.literal('z_token'),
  data: zTokenDataSchema,
});

export const zTokenErrorExtraSchema = z.object({
  type: z.literal('z_token_error'),
  data: z.object({
    status: z.string(),
    detail: z.string(),
  }),
});

export type ZTokenData = z.infer<typeof zTokenDataSchema>;

export const sessionDataSchema = z
  .object({
    id: z.string(),
    expires_at: z.string().datetime(),
    token: z.string(),
    user_id: z.string(),
    level: z.string().optional(),
    extra: z
      .object({
        z: z.union([zTokenExtraSchema, zTokenErrorExtraSchema]).optional(),
      })
      .optional(),
  })
  .passthrough();

export const sessionResponseSchema = z
  .object({
    type: z.literal('session'),
    data: sessionDataSchema,
  })
  .passthrough();

export type SessionData = z.infer<typeof sessionDataSchema>;
export type SessionResponse = z.infer<typeof sessionResponseSchema>;
